module.exports = __webpack_public_path__ + "img/get-btn.b5f8821e.png";